import 'selectize';
import Cookies from "js-cookie";
import Message from "../components/Message";

export default (function (w, d) {
        'use strict';

        function ProductUploadController() {
            this.initProductUpload();
            this.initFileUpload();
        }

        ProductUploadController.prototype.initProductUpload = function () {
            $('.selectize-search-brand').selectize({
                delimiter: ',',
                persist: true,
            });

            $('.selectize-search-material').selectize({
                delimiter: ',',
                persist: true,
                // maxItems:5
            });

            $('.selectize-search-pattern').selectize({
                delimiter: ',',
                persist: true,
                // maxItems:5
            });

            (function ($) {
                $('.main_category').on('change', function (e) {
                    $('.sub_category_wrapper').hide();
                    $('.sub_sub_category_wrapper').hide();
                    const categoryId = $(this).val();
                    get_child_categories(categoryId, $('.category_content'), 'subcategory_input', 'category');
                    $('#size').val('');
                });

                $(document).on('change', '.subcategory_input', function (e) {
                    $('.sub_sub_category_wrapper').hide();
                    const categoryId = $(this).val();
                    get_child_categories(categoryId, $('.sub_category_content'), 'sub_sub_category_input', 'subcategory');
                    load_product_sizes(categoryId);
                    $('#size').val('');
                });

                $(document).on('change', '.sub_sub_category_input', function (e) {
                    const categoryId = $(this).val();
                    get_child_categories(categoryId, $('.sub_sub_category_content'), 'sub_sub_sub_category_input', 'sub_subcategory');
                    load_product_sizes(categoryId);
                    $('#size').val('');
                });

                $(document).on('change', '.sub_sub_sub_category_input', function (e) {
                    const categoryId = $(this).val();
                    load_product_sizes(categoryId);
                    $('#size').val('');
                });

                $(document).on('change', '#size_system', function (e) {
                    const selected_subcategory = $('.sub_sub_category_input:checked').val() ?? '';
                    const selected_sub_subcategory = $('.sub_sub_sub_category_input:checked').val() ?? '';

                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.get(`categories/get-sizes?size_country=${$(this).val()}&selected_subcategory=${selected_subcategory}&selected_sub_subcategory=${selected_sub_subcategory}`, function (response) {
                        $('#size').html('').prepend(
                            $('<option/>').attr('disabled', 'disabled').text('Choose...')
                        );
                        $.each(response, function (index, size) {
                            const $option = $('<option/>').text(size);
                            if (index === 0) {
                                $option.attr('selected', 'selected');
                            }
                            $('#size').append($option);
                        });
                    });
                });

                let entered_price = $("#purchase-price");
                let url = "/sell/calc-price";
                calc_p_for_u(entered_price.val());

                function load_product_sizes(categoryId) {
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.get(`/categories/${categoryId}/countries`, function (response) {
                        if (response.length !== 0 && typeof response !== 'undefined') {
                            $('.size_wrapper').show();
                        }
                        $('#size_system').html('').prepend(
                            $('<option/>').attr('disabled', 'disabled').attr('selected', 'selected').text('Choose...')
                        );
                        $.each(response, function (index, size) {
                            $('#size_system').append(
                                $('<option/>').text(size)
                            );
                        });
                    });
                }

                function get_child_categories(categoryId, element, inputClass, name) {
                    $(element).html('');

                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    let url = route('sell.get_child_categories',{categoryId:categoryId});
                    $.get(url, function (response) {
                        if (response?.categories?.length) {
                            switch (name) {
                                case 'category':
                                    $('.category_wrapper').show();
                                    break;
                                case 'subcategory':
                                    $('.sub_category_wrapper').show();
                                    break;
                                case 'sub_subcategory':
                                    $('.sub_sub_category_wrapper').show();
                                    break;
                            }
                        }

                        $.each(response.categories, function (index, childCategory) {
                            $(element).append($('<div/>').addClass('radio-box-payment').prepend(
                                $('<label/>').text(childCategory.name).append(
                                    $('<input/>').addClass(`optional-select ${inputClass}`).attr({
                                        id: `${inputClass}_${childCategory.id}`,
                                        name: name,
                                        type: "radio",
                                        value: childCategory.id,
                                    })
                                ).append(
                                    $('<span/>').addClass('radiomark')
                                ))
                            )
                        });
                    });
                }

                function calc_p_for_u($price) {
                    if ($price) {
                        $.ajaxSetup({
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        });

                        $.post(url, {price: parseFloat($price)}, function (response) {
                            document.getElementById('last-price').innerHTML = response.price;
                        });
                    }
                }

                entered_price.on("blur", function () {
                    if (entered_price.val() * 1 < entered_price.attr('min') * 1) {
                        Message(window.minPriceErrorMsg, 'error');
                        entered_price.css('border', '1px solid red');
                    } else {
                        entered_price.css('border', '1px solid #292929');
                    }
                });

                entered_price.on("change keyup", function () {
                    calc_p_for_u(entered_price.val());
                });

                $(".submit_button").on('click', function (e) {
                    e.preventDefault();

                    const form = $('form#step1');

                    if ($(this).hasClass('fill_product')) {
                        $(form).append(
                            $('<input/>').attr('type', 'hidden').attr('name', 'fill').val(1)
                        );
                    } else {
                        $(form).append(
                            $('<input/>').attr('type', 'hidden').attr('name', 'fill').val(0)
                        );
                    }

                    const formData = new FormData(form[0]);
                    const url = form[0].action;
                    fetch(url, {method: 'POST', body: formData})
                        .then(response => response.text())
                        .then(text => {
                            try {
                                const data = JSON.parse(text);
                                if (!data.success) {
                                    const errorTypes = [
                                        'purchase_price',
                                        'brand',
                                        'main-category',
                                        'color',
                                        'material',
                                        'pattern',
                                        'description',
                                        'files',
                                        'condition'
                                    ];

                                    errorTypes.forEach(key => {
                                        const messages = data.messages[key] ? data.messages[key].join('<br>') : null;
                                        if (messages) {
                                            $(`#error_${key}`).html(messages).removeClass('d-none');
                                        } else {
                                            $(`#error_${key}`).html('').addClass('d-none');
                                        }
                                    });

                                    new Message(data.message, 'error');
                                    return;
                                }

                                if (data.redirect_to !== undefined) {
                                    window.location = data.redirect_to;
                                }
                            } catch(err) {
                                new Message('Product upload server error. Contact the administrator', 'error');
                            }
                        });
                });
            }(jQuery))
        }

        ProductUploadController.prototype.initFileUpload = function () {
            for (let i = 0; i <= 5; i++) {
                this.initFileInputUpload(i);
                this.initFileInputRemove(i);
            }
        }

        ProductUploadController.prototype.initFileInputUpload = function (index) {
            $(`#file-input-${index}`).on('change', function (e) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    $(`.file_box_${index}`).find('label').remove();
                    $(`.file_box_${index}`).css({
                        'background-image': 'url(' + e.target.result + ')',
                        'background-size': '100% 70%',
                        'background-repeat': 'no-repeat',
                        'background-position': 'bottom center',
                        'position': 'relative'
                    });
                    $('<a/>').attr('href', 'javascript:void(0)').addClass(`file_box_image_remove-${index}`).append(
                        $('<i/>').append(
                            $('<img/>').attr('src', '/assets/build/images/icons/trash.svg')
                                .css({
                                    'height': '20px',
                                })
                        )
                    ).css({
                        'position': 'absolute',
                        'type': 'button',
                        'outline': 'none',
                        'border': 'none',
                        'background': 'transparent',
                        'left': '45%',
                        'top': '10px'
                    }).appendTo($(`.file_box_${index}`));
                }
                reader.readAsDataURL(e.target.files[0]);
                $(`.file-input-${index}-title`).text(e.target.files[0].name);
            });

            $(document).on('change', '.file_input', function (e) {
                let i = $(this).data('key');
                const reader = new FileReader();
                reader.onload = (e) => {
                    $(`.file_box_${i}`).find('label').remove();
                    $(`.file_box_${i}`).css({
                        'background-image': 'url(' + e.target.result + ')',
                        'background-size': '100% 70%',
                        'background-repeat': 'no-repeat',
                        'background-position': 'bottom center',
                        'position': 'relative'
                    });
                    $('<a/>').attr('href', 'javascript:void(0)').addClass(`file_box_image_remove-${i}`).append(
                        $('<i/>').append(
                            $('<img/>').attr('src', '/assets/build/images/icons/trash.svg')
                                .css({
                                    'height': '20px',
                                })
                        )
                    ).css({
                        'position': 'absolute',
                        'type': 'button',
                        'outline': 'none',
                        'border': 'none',
                        'background': 'transparent',
                        'left': '45%',
                        'top': '10px'
                    }).appendTo($(`.file_box_${i}`));
                }
                reader.readAsDataURL(e.target.files[0]);
                $(`.file-input-${i}-title`).text(e.target.files[0].name);
            });
        }

        ProductUploadController.prototype.initFileInputRemove = function (index) {
            $(document).on('click', `.file_box_image_remove-${index}`, function () {
                $(`.file_box_${index}`).html('').removeAttr('style');
                $(`.file-input-${index}-title`).remove();
                $('<label/>').attr('for', `file-input-${index}`).append(
                    $('<div/>').addClass('text').append(
                        $('<i/>').addClass('upload-icon')
                    ).append(
                        $('<div/>').addClass('image-title').text('Įkelti prekės nuotrauką')
                    )
                ).appendTo($(`.file_box_${index}`))

                let images_to_delete = $('.images_to_delete').val();
                if (images_to_delete !== undefined) {
                    images_to_delete = images_to_delete.split(',');
                    let image_to_delete = $(this).data('image-id');
                    images_to_delete.push(image_to_delete);
                    $('.images_to_delete').val(images_to_delete.toString());
                }

                $('<input/>').attr('id', `file-input-${index}`).addClass('file_input').attr('data-key', index).attr('name', 'files[]')
                    .attr('type', 'file').appendTo($(`.file_box_${index}`))
            });
        }

        return ProductUploadController;
    }
    (window, document)
);

